import { Component, Input } from '@angular/core';
import { PartnerInformation } from '../../../../core-data-model';
import { TranslationService } from '../../../../translations';

@Component({
    selector: 'consultant-contact-details',
    template: `
        @if (displayComponent) {
            <div class="title">
                {{ TR.key('subscription-manager.overview-consultant-contact') }}
            </div>
            <dl class="inlineDL">
                <dd class="content">
                    {{ consultantName }}<br />
                    <span
                        [style.display]="partnerInfo.phone ? 'auto' : 'none'"
                        piTesting="consultant-phone"
                    >
                        <span class="consultant-detail">
                            {{
                                TR.key(
                                    'subscription-manager.overview-consultant-contact-phone'
                                )
                            }}
                        </span>
                        <span class="consultant-detail-value">
                            {{ partnerInfo.phone }} </span
                        ><br />
                    </span>
                    <span
                        [style.display]="partnerInfo.email ? 'auto' : 'none'"
                        piTesting="consultant-email"
                    >
                        <span class="consultant-detail">
                            {{
                                TR.key(
                                    'subscription-manager.overview-consultant-contact-email'
                                )
                            }}
                        </span>
                        <span class="consultant-detail-value">
                            {{ partnerInfo.email }} </span
                        ><br />
                    </span>
                </dd>
            </dl>
        }
    `,
    styleUrls: ['./consultant-contact.component.less'],
    standalone: false
})
export class AccountSubscriptionManagerConsultantContactComponent {
    @Input()
    partnerInfo: PartnerInformation;
    @Input()
    website: string;

    constructor(public TR: TranslationService) {}

    get displayComponent(): boolean {
        return !!this.partnerInfo?.fullName || !!this.partnerInfo?.phone;
    }

    get consultantName(): string {
        return (
            this.partnerInfo?.fullName ??
            this.TR.key('billing-manager.details.no-consultant')
        );
    }
}
